/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import validate from 'validate.js';

import * as selectorsControleFrequencias from '../../store/controleFrequencia/reducer';
import * as actionsControleFrequencias from '../../store/controleFrequencia/actions';
import * as selectorsAuth from '../../store/auth/reducer';
import * as Role from '../../constants/role';
import moment from 'moment';

import { DialogDefault, Input, InputFormat, UsuarioSelect, OptionSelect, DatePicker } from '../../components';
import { convertTimeToMinutes, isNullOrUndefined, isValidTime, formatToTime } from 'utils';

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  },
  buttonContainer: {
    width: '100%'
  }
}));

const defaultSchema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ocorrenciaId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspetor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inicioJornada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const validateInvalidTimes = values => {
  let errors = {};

  if (!isNullOrUndefined(values.inicioJornada) && !isValidTime(values.inicioJornada)) {
    errors = { ...errors, inicioJornada: ['Horário inválido'] }
  }

  if (!isNullOrUndefined(values.inicioIntervalo) && !isValidTime(values.inicioIntervalo)) {
    errors = { ...errors, inicioIntervalo: ['Horário inválido'] }
  }

  if (!isNullOrUndefined(values.finalIntervalo) && !isValidTime(values.finalIntervalo)) {
    errors = { ...errors, finalIntervalo: ['Horário inválido'] }
  }

  if (!isNullOrUndefined(values.finalJornada) && !isValidTime(values.finalJornada)) {
    errors = { ...errors, finalJornada: ['Horário inválido'] }
  }

  return errors;
}

const hasError = (values, horaExtraDisabled) => {
  let schema = defaultSchema;
  if (!horaExtraDisabled) {
    schema = {
      ...schema,
      horaExtraAutorizadoPor: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      horaExtraJustificativa: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    }
  }

  return {
    ...validate(values, schema),
    ...validateInvalidTimes(values),
  }
}

const Formulario = ({ open, id, onClose, loadControleFrequencia, controleFrequencia, saveControleFrequencia, authData }) => {
  const classes = useStyles();

  const [readOnly, setReadOnly] = useState(false);
  const [errors, setErrors] = useState({});
  const [horaExtraDisabled, setHoraExtraDisabled] = useState(true);
  const [values, setValues] = useState({
    data: moment().valueOf(),
    tipoControle: "FOLHA_PONTO",
  });

  useEffect(() => {
    if (id) loadControleFrequencia(id);
  }, [id, loadControleFrequencia]);

  useEffect(() => {
    if (id && controleFrequencia && id == controleFrequencia.id) {
      setValues({ ...controleFrequencia, data: moment(parseInt(controleFrequencia.data)).valueOf() });
      setReadOnly(authData.id != controleFrequencia.criadoPor)
    } else {
      setValues({ data: moment().valueOf(), tipoControle: "FOLHA_PONTO", });
      setReadOnly(false);
    }
  }, [controleFrequencia, id]);

  const onSave = () => {
    const erros = hasError(values, horaExtraDisabled);
    if (erros != null && Object.keys(erros).length > 0) {
      setErrors(erros);
      return;
    }

    debugger
    saveControleFrequencia(values, () => onCloseLocal(true));
  }

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({ data: moment().valueOf(), tipoControle: "FOLHA_PONTO", });
    setReadOnly(false);
    onClose(isSave);
  }

  const onChange = async (e, field) => {
    const value = e.target.value;

    const inicioJornadaMinutes = convertTimeToMinutes(field == "inicioJornada"? value : values.inicioJornada);
    const inicioIntervaloMinutes = convertTimeToMinutes(field == "inicioIntervalo"? value : values.inicioIntervalo);
    const finalIntervaloMinutes = convertTimeToMinutes(field == "finalIntervalo"? value : values.finalIntervalo);
    const finalJornadaMinutes = convertTimeToMinutes(field == "finalJornada"? value : values.finalJornada);

    const first = (inicioJornadaMinutes && inicioIntervaloMinutes && inicioIntervaloMinutes > inicioJornadaMinutes) ? inicioIntervaloMinutes - inicioJornadaMinutes : null;
    const second = (finalJornadaMinutes && finalIntervaloMinutes && finalJornadaMinutes > finalIntervaloMinutes) ? finalJornadaMinutes - finalIntervaloMinutes : null;
    const jornadaTotal = first !== null || second !== null ? (first || 0) + (second || 0) : null;

    setValues({
      ...values,
      [field]: value,
      jornadaTotal: jornadaTotal ? formatToTime(jornadaTotal) : null,
      jornadaTotalMinutes: jornadaTotal,
    });

    validateHoraExtra(values.data, jornadaTotal);
  }

  const validateHoraExtra = (data, jornadaTotalMinutes) => {
    if (data) {
      const day = (new Date(data)).getDay();
      if (day === 0) {
        setHoraExtraDisabled(false);
      }
    }


    if (!jornadaTotalMinutes || !data) return; 

    const day = (new Date(data)).getDay();

    let horaExtraDisabled = true
    if (day === 0) {
      horaExtraDisabled = false;
    } else if (day === 6) {
      horaExtraDisabled = jornadaTotalMinutes <= 4 * 60;
    } else {
      horaExtraDisabled = jornadaTotalMinutes <= 8 * 60;
    }

    setHoraExtraDisabled(horaExtraDisabled);
  }

  return (
    <>
      <DialogDefault
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Ponto Diário"
        confirmMessage="Salvar"
        contentClassName={classes.contentClassName}
        maxWidth="md"
        readOnly={readOnly}
      >
        <Grid container spacing={3} className={classes.gridContainer}>
          <Grid item xs={4} className={classes.fieldContainer}>
            <DatePicker
              label={'Data'}
              onChange={data => {
                setValues({ ...values, data: data });
                validateHoraExtra(data, values.jornadaTotalMinutes);
              }}
              value={values.data}
              isRequired
              error={errors && errors.data}
              showInput
              disabled={readOnly}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <OptionSelect
              label="Ocorrência"
              codigo="PONTO_OCORRENCIA"
              isRequired
              error={errors && errors.ocorrenciaId}
              onSelect={ocorrenciaId => setValues({
                ...values,
                ocorrenciaId
              })}
              value={values.ocorrenciaId}
              disabled={readOnly}
            />
          </Grid>
          <Grid item xs={4}>
            <UsuarioSelect
              label="Inspetor"
              onSelect={inspetor => setValues({
                ...values,
                inspetor
              })}
              isRequired
              error={errors && errors.inspetor}
              grupos={[Role.ADMIN, Role.INSPETOR]}
              value={values.inspetor}
              disabled={readOnly}
            />
          </Grid>
          <Grid item xs={4}>
            <UsuarioSelect
              label="Parceiro"
              onSelect={inspetorAuxiliar => setValues({
                ...values,
                inspetorAuxiliar
              })}
              grupos={[Role.ADMIN, Role.INSPETOR]}
              value={values.inspetorAuxiliar}
              disabled={readOnly}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <InputFormat
              label="Inicio Jornada"
              value={values.inicioJornada}
              onChange={e => onChange(e, "inicioJornada")}
              format="##:##"
              placeholder="HH:MM"
              disabled={readOnly}
              isRequired
              error={errors && errors.inicioJornada}
              helperText={errors && errors.inicioJornada ? errors.inicioJornada : null}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <InputFormat
              label="Inicio Intervalo"
              value={values.inicioIntervalo}
              onChange={e => onChange(e, "inicioIntervalo")}
              format="##:##"
              placeholder="HH:MM"
              disabled={readOnly}
              error={errors && errors.inicioIntervalo}
              helperText={errors && errors.inicioIntervalo ? errors.inicioIntervalo : null}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <InputFormat
              label="Final Intervalo"
              value={values.finalIntervalo}
              onChange={e => onChange(e, "finalIntervalo")}
              format="##:##"
              placeholder="HH:MM"
              disabled={readOnly}
              error={errors && errors.finalIntervalo}
              helperText={errors && errors.finalIntervalo ? errors.finalIntervalo : null}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <InputFormat
              label="Final Jornada"
              value={values.finalJornada}
              onChange={e => onChange(e, "finalJornada")}
              format="##:##"
              placeholder="HH:MM"
              disabled={readOnly}
              error={errors && errors.finalJornada}
              helperText={errors && errors.finalJornada ? errors.finalJornada : null}
            />
          </Grid>
          <Grid item xs={4} className={classes.fieldContainer}>
            <Input label="Hora Total Trabalhada" disabled value={values.jornadaTotal} />
          </Grid>
          <Grid item xs={4}>
            <UsuarioSelect
              label="Hora Extra Autorizado Por"
              onSelect={horaExtraAutorizadoPor => setValues({
                ...values,
                horaExtraAutorizadoPor
              })}
              grupos={[Role.ADMIN, Role.SUPER_ADMIN]}
              value={values.horaExtraAutorizadoPor}
              disabled={horaExtraDisabled || readOnly}
              isRequired={!horaExtraDisabled}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              label="Justificativa Hora Extra"
              name="horaExtraJustificativa"
              onChange={event => setValues({ ...values, horaExtraJustificativa: event.target.value })}
              value={values.horaExtraJustificativa}
              rows={3}
              multiline
              disabled={horaExtraDisabled || readOnly}
              isRequired={!horaExtraDisabled}
            />
          </Grid>
        </Grid>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  controleFrequencia: selectorsControleFrequencias.getSelectedControleFrequencia(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsControleFrequencias
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
